// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"72":"thanks","189":"brief","314":"style","444":"designs","691":"colors"}[chunkId] || chunkId) + "-legacy." + {"72":"0a691f8b","189":"55ff69fe","314":"56cd0588","423":"aa4ac66e","444":"61fcf392","520":"6a1bf860","605":"7f61ee86","691":"02552636","973":"0d333093","999":"dea74053"}[chunkId] + ".js";
};